import styled from '@emotion/styled';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { color, font } from 'src/shared/styles/variables';

interface Props {
    filtersCount: number;
    onClick: () => void;
}

export enum PreferencesButtonTestID {
    Button = 'PreferencesButtonTestID.Button',
}

interface ActiveProps {
    active: boolean;
}

const ButtonWrapper = styled.div<ActiveProps>(props => ({
    backgroundColor: props.active ? color.cornflowerBlueDark : color.white,
    border: `2px solid ${props.active ? color.cornflowerBlueDark : color.catskillWhite}`,
    borderRadius: 50,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    paddingLeft: 40,
    paddingRight: 40,
    cursor: 'pointer',
}));

const Label = styled.h3<ActiveProps>(props => ({
    color: props.active ? color.white : color.pickledBluewood,
    ...font.heavy(font.size.base),
    marginLeft: 10,
}));

const Icon = styled(FontAwesomeIcon)({
    fontSize: font.size.medium,
});

export const PreferencesButton: React.FC<Props> = ({ filtersCount, onClick }) => {
    const { t } = useTranslation();

    const isActive = filtersCount > 0;

    return (
        <ButtonWrapper
            data-testid={PreferencesButtonTestID.Button}
            onClick={onClick}
            active={isActive}
        >
            <Icon icon={faSlidersH} color={isActive ? color.white : color.blueBayoux} />
            <Label active={isActive}>
                {isActive
                    ? t('providers:preferences_button.text_active', {
                          count: filtersCount,
                      })
                    : t('providers:preferences_button.text')}
            </Label>
        </ButtonWrapper>
    );
};
